import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

const GAP_PX = 20;

export const useMessengerBesideMenu = (enabled: boolean, menuWidthPx: number) => {
  const { update } = useIntercom();
  useEffect(() => {
    if (!enabled) return;
    update({ hideDefaultLauncher: true, alignment: "left", horizontalPadding: menuWidthPx + GAP_PX });
    return () => update({ hideDefaultLauncher: false, alignment: "right", horizontalPadding: GAP_PX });
  }, [enabled, menuWidthPx, update]);
};
